import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "./cn.js";
/** Always-visible sync indicator (build plan rule 2). Labels are passed in so the app owns translations. */
export function SyncPill({ state, pending = 0, labels, className }) {
    const tone = {
        synced: "bg-green-soft text-green-ink",
        syncing: "bg-[#e6ecfb] text-navy",
        pending: "bg-[#fbefd9] text-[#8a570b]",
        offline: "bg-tint text-ink-2",
        error: "bg-[#fbe3e3] text-danger",
    };
    return (_jsxs("span", { role: "status", "aria-live": "polite", className: cn("inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1.5 text-[11px] font-medium", tone[state], className), children: [_jsx("span", { "aria-hidden": true, className: cn("size-1.5 shrink-0 rounded-full bg-current", state === "syncing" && "animate-pulse") }), labels[state], pending > 0 && state !== "synced" ? ` · ${pending}` : ""] }));
}
//# sourceMappingURL=SyncPill.js.map